import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { StatusbarModule } from "../../core/statusbar/statusbar.module";



@NgModule({
    declarations: [
        FooterComponent
    ],
    exports: [FooterComponent],
    imports: [
        CommonModule,
        StatusbarModule
    ]
})
export class FooterModule { }
